export default __webpack_public_path__ + "static/media/misc-pantry1-1024w.0a464a55.webp";